import DapDSInput from './input.component'

export * from './input.component'
export default DapDSInput

DapDSInput.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-input': DapDSInput
  }
}
